import { render, staticRenderFns } from "./appointmentxhIndexNew.vue?vue&type=template&id=4e4129a8&scoped=true&"
import script from "./appointmentxhIndexNew.vue?vue&type=script&lang=js&"
export * from "./appointmentxhIndexNew.vue?vue&type=script&lang=js&"
import style0 from "./appointmentxhIndexNew.vue?vue&type=style&index=0&id=4e4129a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4129a8",
  null
  
)

export default component.exports